import {CHANGE_LANGUAGE} from "../types";

export default current => {
  return({
    type: CHANGE_LANGUAGE,
    payload: {
      auth: {
        language: current === 'es' ? 'en' : 'es'
      }
    }
  });
};